export const header = `
<header
  id="header"
>
  <div
    class="pl-20 table-cell header-left"
    id="header_left"
  >
    <div class="liquid-tag">{{ client.specialisation }}</div>

  </div>
  <div
    class="table-cell pr-20 right-text-align"
    id="header_right"
  >
    <div class="liquid-tag liquid-operator">{% if client.enabled_page_numbers_raw %}</div>
    <div class="header-page-container"><span>Page <span class="remove-on-processing">X</span> </span><span class="pageNumber"></span> of <span class="remove-on-processing">Y</span> <span class="totalPages"></span></div>
    <div class="liquid-tag liquid-operator">{% endif %}</div>
  </div>
</header>
`;

export const headerStyles = `
  #header {
    width: 100%;
    font-size: 12px;
    display: table;
  }
`;